const paths = {
  articles: '/articles',
  reviews: '/review',
  authors: '/authors',
  reviewers: '/reviewers',
  dentalHealFromAToZ: '/dental-health-A-to-Z',
  searchPageAll: '/search/?all_blogs%5Bquery%5D=',
  searchPageProfessionFilter: '&all_blogs%5BrefinementList%5D%5Bcareers.name%5D%5B0%5D=',
  topics: '/topics',
};

export default paths;
